module.exports = __webpack_public_path__ + "img/storage2.c637641d.png";